const FITNESS_MEMBER_ERROR_MESSAGES = Object.freeze({
  online_cancellation_disabled: "This class can't be cancelled online. Please contact the club if you need help with your booking.",
  already_booked_for_occurrence: 'You are already booked for this class time.',
  slot_unavailable: 'That time is no longer available. Please choose another.',
  fitness_accounting_sync_failed: "We couldn't finalize your booking. Please try again or contact the club.",
  popup_blocked: 'Please allow pop-ups to continue to secure payment.',
})

export const FITNESS_MEMBER_GENERIC_ERROR = "We couldn't complete that request. Please try again or contact the club."

/** Presentation boundary: API/provider details must never become member-visible copy. */
export function getFitnessMemberErrorMessage(code, t) {
  if (t) {
    const keys = { slot_unavailable: 'unavailable', slot_in_past: 'unavailable', already_booked_for_occurrence: 'fitnessAlreadyBooked', popup_blocked: 'popup', fitness_accounting_sync_failed: 'fitnessAccounting' }
    return t(`facilityBooking.${keys[code] || 'fitnessGeneric'}`)
  }
  if (Object.values(FITNESS_MEMBER_ERROR_MESSAGES).includes(code) || code === FITNESS_MEMBER_GENERIC_ERROR) return code
  const normalized = typeof code === 'string' ? code.trim().toLowerCase() : ''
  return FITNESS_MEMBER_ERROR_MESSAGES[normalized] || FITNESS_MEMBER_GENERIC_ERROR
}
